<div class="wrap">
  <div class="social_login" *ngIf="!mailPassword && !loginFfv">
    <div class="apple_connect" *ngIf="ios" (click)="loginWithSocialMedia('apple')">
      <div class="img">
        <img src="assets/img/apple-brands.svg" alt="apple">
      </div>
      <p>Continuer avec Apple</p>
    </div>
    <div (click)="loginWithSocialMedia('facebook')" class="facebook">
      <div class="img">
        <img src="assets/img/facebook-brands.svg" alt="facebook">
      </div>
      <p>Continuer avec Facebook </p>
    </div>
    <div (click)="loginWithSocialMedia('google')" class="google">
      <div class="img">
        <img src="assets/img/google-brands.svg" alt="">
      </div>
      <p>Continuer avec Google</p>
    </div>

    <div (click)="loginFfv=true" class="ffv">
      <div class="img">
        <img src="assets/img/ffv_icone.svg" alt="">
      </div>
      <p>Continuer avec FFVoile</p>
    </div>

    <div class="mail_password" (click)="mailPassword=true">
      <fa-icon [icon]="faEnvelope"></fa-icon>
      <p>Email et mot de passe</p>
    </div>
  </div>
</div>
<app-login-form *ngIf="mailPassword && !loginFfv" [mailPassword]="mailPassword" (newMailPassword)="mailPassword=$event"
  [@mailPassword]></app-login-form>

<app-login-ffv *ngIf="loginFfv && !mailPassword" [loginFfv]="loginFfv" (newLoginFfv)="loginFfv=$event" [@mailPassword]>
</app-login-ffv>